const today = () => new Date().toISOString().slice(0, 10);
const days = (a, b) => Math.round((new Date(a) - new Date(b)) / 86400000);

export const isOverdue = (t) => t.status === "open" && !!t.due_date && t.due_date < today();

// [label, tailwind classes] describing completion timing of a task.
export const taskTiming = (t) => {
  if (!t.due_date) return ["بدون موعد", "bg-slate-100 text-slate-600"];
  if (t.status === "done" || t.status === "review") {
    const d = (t.report?.at || t.completed_at || "").slice(0, 10);
    return d && d <= t.due_date ? ["قبل الموعد", "bg-emerald-100 text-emerald-700"] : [`متأخر ${days(d, t.due_date)} يوم`, "bg-red-100 text-red-700"];
  }
  return isOverdue(t) ? [`متأخرة ${days(today(), t.due_date)} يوم`, "bg-red-100 text-red-700"] : ["جارية", "bg-amber-100 text-amber-700"];
};
